<template>
  <div>
    <!-- 分配 -->
    <el-dialog :title="$t('message.customerAllocation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="400px" center>
      <div class="allot">
        <el-select v-model="datas.y_id" class="item" filterable>
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="datas.g_id" class="item" filterable>
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="datas.p_id" class="item" filterable>
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="allotSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
    personnelData: { type: Object },
  },
  data() {
    return {
      //   批量分配
      dialogVisible: false,
      datas: {

      },

    };
  },
  computed: {
    y() {
      return this.personnelData.y;
    },
    g() {
      return this.personnelData.g;
    },
    p() {
      return this.personnelData.p;
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.datas = {
          user_id: [],
          y_id: '',
          p_id: '',
          g_id: '',
        }
        this.selectList.forEach(item => {
          this.datas.user_id.push(item.id)
        })
      }
    },
  },
  methods: {
    // 分配
    allotSave() {
      this.$api.clienteleApi.setClientAdmins(this.datas).then((res) => {
        this.$parent.clientList();
        this.$parent.selectList = [];
        this.dialogVisible = false;
      });

    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-select {
  width: 100%;
}

.allot {
  margin-bottom: 10px;
}
</style>